import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

import { MsisdnApiResponse } from "@core/models/api.response";

@Injectable({
  providedIn: "root",
})
export class MsisdnService {
  constructor(private http: HttpClient) {}

  validateMsisdn(number: string): Observable<MsisdnApiResponse> {
    return this.http.post<MsisdnApiResponse>(
      `${environment.apiUri}/profile/msisdn/exists`,
      {
        msisdn: number,
      }
    );
  }
}
